import React from 'react';
import * as C from "../componentsM/index";
import { Outlet } from 'react-router-dom';
// import '../global.css';
const RootLayout = () => {
    return (
        <>
            
            <C.Navbar />
            <Outlet />
            <C.Footer />
        </>
    )
}

export default RootLayout